import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUserInfo, addUserName, clearUserData } from "../../redux/slices/userSlice";
import { fetchCredeauData } from "../../lib/credlibkit";
import { storeAccessToken, storeAttributeKey, storeCustomerID, storeLeadID, storePhoneNo, storeProductId, storeToken } from "../../utils/storage";
import ServicesAPI from "../../services/services";
import { handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import Cookies from "js-cookie";
import { clearRegisterData } from "../../redux/slices/registerSlice";

export default function AutoLogin() {
  const [searchParams] = useSearchParams();

  const { autoLoginAPI } = new ServicesAPI();

  const token = searchParams.get("token");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      handleAutoLogin();
    }
  }, [token]);

  const handleAutoLogin = async () => {
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookieName) => {
      Cookies.remove(cookieName, { path: "/" });
    });

    localStorage.clear();
    dispatch(clearUserData());
    dispatch(clearRegisterData());

    await new Promise((res) => setTimeout(res, 2000));

    try {
      const res = await autoLoginAPI(token);

      const jwtToken = res.data.jwtToken;
      const accessToken = res.data.accessToken;
      const customerID = res.data.customer.customerID;
      const phoneNo = res?.data?.customer?.mobile;

      storeToken(jwtToken);
      storeAccessToken(accessToken);
      storeCustomerID(customerID);
      storePhoneNo(phoneNo);
      localStorage.setItem("customerType", res?.data?.lead?.customer_type);
      storeProductId(res?.data?.lead?.productId);
      storeLeadID(res?.data?.lead?.leadID);
      storeAttributeKey(res?.data?.attributeKey);

      dispatch(addUserName(res?.data?.customer?.name));
      dispatch(addUserInfo(res?.data?.customer));

      // Credeau SDK
      fetchCredeauData(res?.data?.customer?.customerID);
      localStorage.setItem("custId", res?.data?.customer?.customerID);

      setTimeout(() => {
        navigate("/home");
      }, 100);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return <div>{handleShowContextualLoader("Please wait...")}</div>;
}
